import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-driver-report-modal',
  templateUrl: './driver-report-modal.component.html',
  styleUrls: ['./driver-report-modal.component.css']
})
export class DriverReportModalComponent implements OnInit, OnDestroy {
  @Input('selectedDriver') selectedDriver: any;
  @Input('preFundingSource') preFundingSource: any;
  @Input('dateRange') dateRange: any;
  @Output() onClose = new EventEmitter<any>();
  driverTrips = [];
  todayDate;
  timeZone;
  user;


  constructor(
    private csvService : CsvService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
  ) { }

  ngOnInit() {
    console.log('Selected Driver:', this.selectedDriver);
    this.getTrips();
  }


  getTrips() {

    this.assignTripService.getAssignManifestDriverReport({
      scheduleTime: this.dateRange[0],
      endDate: this.dateRange[1],
      driverId: this.selectedDriver._id,
      status: 'completed'
    })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if(data.assigns)
          this.driverTrips = data.assigns;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  close() {
    this.onClose.emit(null);
  }

  downloadCsv() {
    this.csvService.generateDriverCSV(this.driverTrips, this.preFundingSource, this.selectedDriver, this.dateRange)
  }

  ngOnDestroy(): void {
  }
}
